import script from "./productSystemItem.vue?vue&type=script&setup=true&lang=js"
export * from "./productSystemItem.vue?vue&type=script&setup=true&lang=js"

import "./productSystemItem.vue?vue&type=style&index=0&id=6b816bb8&scoped=true&lang=less"

import exportComponent from "/workspace/office-website/company-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b816bb8"]])

export default __exports__